import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-4 flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/2a3205e7e8ef8b3d476f9ddb9e8c5218/54cee621a47cdd3d88714c3544241b83.png" 
                alt="Legacy Business Acquisitions LLC" 
                className="h-32 w-32 object-contain brightness-0 invert"
              />
              <div className="flex flex-col">
                <span className="font-playfair text-4xl font-bold leading-tight">LEGACY</span>
                <span className="text-lg font-medium text-gray-300">Business Acquisitions</span>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Creating smooth, confidential exits that protect your people, customers, and reputation, wherever you do business.
            </p>
            <div className="flex items-center space-x-2 text-sm text-gray-300">
              <i className="ri-mail-line"></i>
              <span>brian@legacybusinessacq.com</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#C9A227] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#C9A227] transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/sell-your-business" className="text-gray-300 hover:text-[#C9A227] transition-colors">
                  Sell Your Business
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#C9A227] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4">Our Focus</h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>Service businesses</li>
              <li>Trade and contractor businesses</li>
              <li>Owner-operated businesses</li>
              <li>Typically $150k-$2M in annual owner earnings</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Legacy Business Acquisitions LLC. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-[#C9A227] text-sm transition-colors mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
